export const turkceToEnglish = (text) => {
  const trMap = {
    ç: "c",
    Ç: "C",
    ğ: "g",
    Ğ: "G",
    ı: "i",
    İ: "I",
    ö: "o",
    Ö: "O",
    ş: "s",
    Ş: "S",
    ü: "u",
    Ü: "U",
    â: "a",
    Â: "A",
  }

  return text
    .replace(/[çğıöşüâÂÇĞİÖŞÜ]/g, (letter) => trMap[letter] || letter) // Türkçe karakterler
    .replace(/['"!?.,:;+…&()$€£₺‘’“”]/g, "") // Belirtilen noktalama işaretleri ve para birimleri
    .replace(/\//g, "-") // / karakterini - yap
    .replace(/\s+/g, "-") // Boşlukları tek tireye çevir
    .replace(/-+/g, "-") // Çoklu tireleri tek tire yap
    .replace(/^-+|-+$/g, "") // Baş ve sondaki tireleri kaldır
    .toLowerCase() // Küçük harfe çevir
}
